
    import '/vercel/path0/docs/guide/i18n.md?watch=parent';
    export const toc = [{"id":"多语言","depth":1,"title":"多语言"}];
export const frontmatter = {"title":"多语言","toc":"menu","filename":"docs/guide/i18n.md","lastUpdated":1714978154000,"group":{"title":"进阶","order":1},"order":0,"description":"当我们想为文档站点增加多语言支持时，只需要在 .dumirc.ts 通过 locales 增加多语言配置，例如："};